import { render, staticRenderFns } from "./CreateDesktopMobileWalkthroughModal.vue?vue&type=template&id=ca2e7f28&"
import script from "./CreateDesktopMobileWalkthroughModal.vue?vue&type=script&lang=ts&"
export * from "./CreateDesktopMobileWalkthroughModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2151985205/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca2e7f28')) {
      api.createRecord('ca2e7f28', component.options)
    } else {
      api.reload('ca2e7f28', component.options)
    }
    module.hot.accept("./CreateDesktopMobileWalkthroughModal.vue?vue&type=template&id=ca2e7f28&", function () {
      api.rerender('ca2e7f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/modals/CreateDesktopMobileWalkthroughModal.vue"
export default component.exports